import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { get } from 'lodash-es'
import { chatbotEvents } from '../state'
import { portfolioApiEvents } from 'modules/api/portfolio'

export interface LeaseSettingsState {
  notes: string
  customLeaseIdentifier: string
  autoSendPaymentReminderSms: boolean | null
  autoSendOwnerMonthlyEmail: boolean | null
  segments: any[]
}

export const initialState: LeaseSettingsState = {
  notes: '',
  customLeaseIdentifier: '',
  autoSendPaymentReminderSms: null,
  autoSendOwnerMonthlyEmail: null,
  segments: [],
}

const leaseSettingsSlice = createSlice({
  name: 'chatbot/dialogs/leaseSettings',
  initialState,
  reducers: {
    settingsSaved: (state, action: PayloadAction<Partial<LeaseSettingsState>>) => {
      Object.assign(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(chatbotEvents.setCurrentPortfolio, (state, action) => {
        Object.assign(state, get(action.payload, 'settings', {}))
      })
      .addCase(portfolioApiEvents.amendSettings_success, (state, action) => {
        Object.assign(state, action.payload)
      })
      .addCase(chatbotEvents.resetCurrentPortfolio, () => initialState)
  },
})

export const { reducer } = leaseSettingsSlice
export const leaseSettingsEvents = leaseSettingsSlice.actions
